import React from 'react';
import { Container } from 'reactstrap';
import { graphql } from 'gatsby';

import Link from '../components/Link';
import Layout from '../components/Layout';

const Voices = ({ data }) => {
  const narratives = data.allSitePage.nodes;
  return (
    <Layout title="Voices">
      <Container>
        <div className="section">
          <h1>LVN Voices</h1>
          <p>
            We envision a country connected through more constructive and
            empathic public discourse. Across our LVN conversations participants
            share their lived experience on a variety of subjects across
            communities, whether from farmers in rural Wisconsin, nurses in
            Arkansas, and librarians in New York City and Charlotte. Take a
            moment to explore and hear powerful stories from people just like
            you.
          </p>
          <ul>
            {narratives.map((narrative) => {
              const { path, context } = narrative;
              return (
                <li key={path}>
                  <Link to={path}>{context.title}</Link>
                </li>
              );
            })}
          </ul>
        </div>
      </Container>
    </Layout>
  );
};

export const query = graphql`
{
  allSitePage(filter: {path: {regex: "/^\\/voices\\/\\w+/"}}) {
    nodes {
      path
      context {
        title
        narrativeId
      }
    }
  }
}

`;

export default Voices;
